import {IReviewResult} from "./IReviewResult";
export class IReviewResultSubQuestion {
  id:number;
  title:string;
  question_type_id:number;
  __options:Array<IReviewResult>;
}
